import { getAllPlanning } from '@/api/dispo';
import moment from 'moment';

export default async function getAllDisponibilitesOfTempo(ligneCommandeProduitIds,
  dateDebut, dateFin) {
  const debut = dateDebut ?? moment(new Date()).toDate();
  const fin = dateFin ?? moment(new Date()).toDate();
  const disponibilites = (await getAllPlanning(ligneCommandeProduitIds,
    debut, fin)).data.result;

  return disponibilites;
}
